import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@auth/auth-service';

export const notImpersonatingGuard: CanActivateFn = (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.impersonatedUser()) {
    return true;
  }

  router.navigate(['/']);
  return false;
};
